
import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';
import { getActiveAlertsCount, getAlertTagsCountByMetrics, getAlertTagsCountBySeverity, getDataSource } from './helper';

const selector = state => get(state, SCOPE);

export const loadingSelector = createSelector(
  selector,
  store => store.isFetching,
);

export const fetchedSelector = createSelector(
  selector,
  store => store.isFetched,
);

export const searchKeySelector = createSelector(
  selector,
  store => store.searchKey,
);

export const selectedTabSelector = createSelector(
  selector,
  store => store.selectedTab,
);

export const selectedSeveritiesSelector = createSelector(
  selector,
  store => store.selectedSeverities,
);

export const activeAlertsSelector = createSelector(
  selector,
  store => store.showActiveAlerts,
);

export const selectedMetricsSelector = createSelector(
  selector,
  store => store.selectedMetrics,
);

export const filterSelector = createSelector(
  selector,
  store => store.filter,
);

export const summaryTableSortSelector = createSelector(
  selector,
  store => store.tableSort,
);

export const summaryDataSelector = createSelector(
  selector,
  ({ summaryData, filter }) => {
    if (filter && ('alerts' in summaryData)) {
      const alertIdSet = new Set(filter.alertIds);
      const { alerts } = summaryData;
      const filteredAlerts = alerts.filter(alert => alertIdSet.has(alert.alertId));
      return { ...summaryData, alerts: filteredAlerts };
    }
    return summaryData;
  },
);

export const resultSelector = createSelector(
  summaryDataSelector,
  searchKeySelector,
  (data, searchKey) => {
    // filter data by search key
    if (searchKey && ('alerts' in data)) {
      const lowerSearchKey = searchKey.toLowerCase();
      const { alerts } = data;
      // eslint-disable-next-line max-len
      const filteredAlerts = alerts.filter(item => item.metricDisplayName.toLowerCase().includes(lowerSearchKey)
        || item.rootCauseWithoutFormatting.toLowerCase().includes(lowerSearchKey)
        || item.accountName.toLowerCase().includes(lowerSearchKey)
        || item.c3Name.toLowerCase().includes(lowerSearchKey)
        || item.status.toLowerCase().includes(lowerSearchKey)
        || item.peakSeverity.toLowerCase().includes(lowerSearchKey)
        // eslint-disable-next-line eqeqeq
        || item.alertId == lowerSearchKey);
      return { ...data, alerts: filteredAlerts };
    }
    return data;
  },
);

export const tagsSelector = createSelector(
  resultSelector,
  (records) => {
    const res = {
      alertsBySeverity: {
        all: {},
        EI: {},
        AI: {},
        APP: {},
      },
      alertsByMetric: {},
      alertsByActiveStatus: {
        all: 0,
        EI: 0,
        AI: 0,
        APP: 0,
      },
    };
    const { alerts } = records;
    if (alerts) {
      res.alertsBySeverity = getAlertTagsCountBySeverity(alerts);
      res.alertsByMetric = getAlertTagsCountByMetrics(alerts);
      res.alertsByActiveStatus = getActiveAlertsCount(alerts);
    }
    return res;
  },
);

export const summaryTableDataSelector = createSelector(
  resultSelector,
  selectedTabSelector,
  selectedSeveritiesSelector,
  selectedMetricsSelector,
  summaryTableSortSelector,
  activeAlertsSelector,
  ({ alerts }, tabType, selectedTags, selectedMetrics, sortBy, isActiveSelected) => {
    let data = [];
    if (alerts) {
      data = getDataSource(alerts, tabType, selectedTags, selectedMetrics, sortBy, isActiveSelected)
    }
    return data;
  },
);

export default selector;
